module.exports = __webpack_public_path__ + "static/AccessU-401fe4911e2f1db9a849632b0cf57b12.png";